import React from 'react'
import { Package, ChevronDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { useTheme } from '@/context/ThemeContext'
import { useChatStore } from '../chatStore'

export const ProductSelect = () => {
  const { isDarkMode } = useTheme()
  const { products, selectedProduct, setSelectedProduct, isLoading } = useChatStore()

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={`w-full flex items-center gap-2 text-sm font-semibold ${
            isDarkMode ? 'bg-gray-800 border-gray-700 text-white' : 'bg-white border-gray-300'
          }`}
        >
          <Package className="h-4 w-4 text-[#FF4A8E] mr-2" />
          <span className="font-bold">{isLoading ? 'Loading...' : selectedProduct?.name || 'Select product'}</span>
          <ChevronDown size={16} className="ml-auto" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className={`p-0 w-56 ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white'}`}>
        <div className="py-1">
          {products.map((product) => (
            <Button
              key={product.id}
              variant="ghost"
              className={`w-full justify-start text-left px-3 py-2 h-auto rounded-none ${
                isDarkMode ? 'hover:bg-gray-700 text-white' : 'hover:bg-gray-100'
              }`}
              onClick={() => setSelectedProduct(product)}
            >
              {product.name}
            </Button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default ProductSelect
